jQuery(document).ready(function(){
    
    jQuery('.faq-items .faq-item .faq-question').click(function(){
        

        if( jQuery(this).parent().hasClass('active') ) {
            jQuery(this).parent().removeClass('active');
            jQuery(this).next().slideUp();
        } else {
            jQuery('.faq-items .faq-item .faq-answer').slideUp();
            jQuery(this).next().slideDown();

            jQuery('.faq-items .faq-item').removeClass('active');
            jQuery(this).parent().addClass('active');
        }
    });

    jQuery('.js-testimonial-slider').owlCarousel({
        loop: true,
        margin: 10,
        nav: false,
        autoHeight: true,
        dots: true,
        items: 1,
        autoplay: true
    });

    jQuery('.js-testimonial').owlCarousel({
        dots: false,
        loop: false,
        nav: true,
        autoHeight: true,
        responsive: {
            0: {
                items: 1,
            },
            768: {
                items: 2,
                margin: 30,
                stagePadding: 150
            }
        }
    });

    jQuery('.section--collection-heading .section--menu h5').click(function(){
        jQuery('.section--collection-heading .section--menu ul').slideUp();
        jQuery(this).next().slideDown();

        const _width = jQuery(this).width();
        const _height = jQuery(this).height() + 50;

        const _top = jQuery(this).position().top;
        const _right = jQuery(this).position().left;

        jQuery(this).next().css({
            top: (_top + _height) + 'px', 
            left: (_right) + 'px'
        });
    });

    jQuery(document).on('click', function(e) {
        if (!jQuery(e.target).closest('.section--collection-heading .section--menu').length) {
            // Click was outside the .section--menu
            jQuery('.section--collection-heading .section--menu ul').slideUp();
        }
    });

    jQuery('.js-hero-slider').owlCarousel({
        loop: false,
        items: 1,
        autoHeight: true,
        autoplay: true,
        autoplayTimeout: 7000,
        autoplayHoverPause: true,
        dots: true,
        nav: false,
        responsive: {
            0: {
                dots: true,
                nav: false,
            },
            768: {
                dots: true,
                nav: true
            }
        }
    });

    if( jQuery(window).width() < 767 ) {
        jQuery('.js-routine').owlCarousel({
            loop: false,
            items: 1,
            dots: false,
            nav: true,
            center: true,
            stagePadding: 50,
            margin: 30,
            responsive: {
                768: {
                    items: 3,
                    stagePadding: 0,
                    margin: 70,
                    center: true,
                }
            }
        });
        }

    const _img = jQuery('.hero-slideshow .owl-item.active .slide img');
    console.log( _img );
    if( _img.length > 0 ) {
        adjustTop( (_img.position().top + _img.height()) - 30 );
    }

    jQuery('a[data-anchor]').click(function(e){
        e.preventDefault();

        const _anchor = jQuery(this).data('anchor');
        console.log( _anchor );

        const _position = (jQuery('.' + _anchor ).offset().top - 50) + 'px';

        jQuery('html, body').animate({
            scrollTop: _position
        }, 500); 
    });

    jQuery('a[href="#product-grid"]').click(function(e){
        e.preventDefault();

        const _href = jQuery(this).attr('href');

        const _position = jQuery( _href ).offset().top + 'px';
        jQuery('html, body').animate({
            scrollTop: _position
        }, 500);
    });

    /*const marqueeContent = document.querySelector('.js-infinite-banner');
    let _position = 0;
    const _speed = 1; // Adjust for desired speed

    if( marqueeContent ) {
        animateMarquee();
    }

    function animateMarquee() {

        _position -= _speed;
        // If the content has scrolled past the point where the duplicate starts
        // reset position to create the loop.
        // The exact reset point depends on the width of your original content.
        if (_position <= -marqueeContent.offsetWidth / 2) {
            _position = 0;
        }
    

        _pos = _position + 'px';

        //marqueeContent.style.transform = `translateX(${position}px)`;
        document.documentElement.style.setProperty('--scroll_pos', _pos);
  


        requestAnimationFrame(animateMarquee);
    }*/

    const marqueeContent = document.querySelector('.js-infinite-banner');
    let _position = 0;
    const _speed = 1; // Adjust for desired speed
    const _throttleInterval = 16; // Target around 60fps (~16ms per frame)

    let lastUpdate = 0;

    if (marqueeContent) {
        animateMarquee();
    }

    function animateMarquee() {
        const now = performance.now();
        const delta = now - lastUpdate;

        // Only update the position every _throttleInterval milliseconds (about 60fps)
        if (delta >= _throttleInterval) {
            _position -= _speed;

            // If the content has scrolled past the point where the duplicate starts, reset position to create the loop
            if (_position <= -marqueeContent.offsetWidth / 2) {
                _position = 0;
            }

            // Update the scroll position using transform instead of directly modifying the style property
            marqueeContent.style.transform = `translateX(${_position}px)`;

            // Update the last update time
            lastUpdate = now;
        }

        requestAnimationFrame(animateMarquee);
    }

});

jQuery(window).on('resize', function(){
    const _img = jQuery('.hero-slideshow .owl-item.active .slide img');
    if( _img.length > 0 ) {
        adjustTop( (_img.position().top + _img.height()) - 30 );
    }
});

function adjustTop(_top) {
    document.documentElement.style.setProperty('--top', _top + 'px');
}
    


